module.exports = "/_next/static/images/576b74f9b0c71d3d0348b71d58453e16-girl-holding-card-landing@xs.jpg";